module.exports = __webpack_public_path__ + "static/media/ozdome.eee68c71.jpg";